"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastModel = void 0;
/*
 * Copyright '2021' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
const uuid_1 = require("uuid");
class ToastModel {
    constructor(text, clickAction = undefined, clickTarget = ToastModel.DEFAULT_CLICK_TARGET, severity = ToastModel.DEFAULT_SEVERITY, dismissAction = undefined, dismissTimeout = ToastModel.DEFAULT_DISMISS_INTERVAL) {
        this.text = "";
        this.clickTarget = ToastModel.DEFAULT_CLICK_TARGET;
        this.severity = ToastModel.DEFAULT_SEVERITY;
        this.dismissTimeout = ToastModel.DEFAULT_DISMISS_INTERVAL;
        this._id = uuid_1.v4();
        this.text = text;
        this.clickAction = clickAction;
        this.clickTarget = clickTarget !== null && clickTarget !== void 0 ? clickTarget : ToastModel.DEFAULT_CLICK_TARGET;
        this.severity = severity !== null && severity !== void 0 ? severity : ToastModel.DEFAULT_SEVERITY;
        this.dismissAction = dismissAction;
        this.dismissTimeout = dismissTimeout !== null && dismissTimeout !== void 0 ? dismissTimeout : ToastModel.DEFAULT_DISMISS_INTERVAL;
    }
    get id() { return this._id; }
}
exports.ToastModel = ToastModel;
ToastModel.DEFAULT_DISMISS_INTERVAL = 10; //seconds
ToastModel.DEFAULT_SEVERITY = 'error'; // error, warning, info, success or custom
ToastModel.DEFAULT_CLICK_TARGET = '_self';
//# sourceMappingURL=toast.model.js.map